export default "__VITE_ASSET__5eceb9dd__"